<template>
  <b-modal
    v-if="dataSignos"
    size="lg" 
    v-model="isVisible"
    hide-footer
    @hidden="onHidden"
  >
    
    <b-card border-variant="primary">
      <h4 class="my-2">Detalles Signos Vitales </h4>
      <hr>
      
      <div>
        <div> 
          <b> Fecha toma:</b> {{ dataCita.fechaCita ? dataCita.fechaCita : "No disponible" }}
        </div>

        <div>
          <b>Paciente: </b> {{ dataPaciente.identificacion }} - {{ dataPaciente.primerApellido }} {{ dataPaciente.primerNombre }} - ({{ edadPaciente }} años)
        </div>
      </div>

      <b-row class="my-2">
          
        <h5 
          class="col-6 my-1"
          :class="temperaturaAlert"
        > 
          <i class="mr-1 fas fa-thermometer"/>
          <b>Temperatura: {{ dataSignos.temperatura }} °C</b>
        </h5>

        <h5 class="col-6 my-1" :class="pulsoAlert"> 
          <i class="mr-1 fas fa-heart"/> 
          <b>Pulso: {{ dataSignos.pulso }} lpm</b>
        </h5>

        <h5 
          class="col-6 my-1"
          :class="satOxigenoAlert"
        > 
          <i class="mr-1 fas fa-wind"/> 
          <b>Saturación Oxigeno: {{ dataSignos.satOxigeno }}%</b>
        </h5>

        <h5 
          class="col-6 my-1"
          :class="tensionAlert"> 
          <i class="mr-1 fas fa-heart"/>
          <b>Presion Arterial:  {{ dataSignos.tensionArterialSistolica }} / {{ dataSignos.tensionArterialDiastolica }} mm Hg </b>
        </h5>

        <h5 class="col-6 my-1" :class="freqRespiratoriaAlert">  
          <i class="mr-1 fas fa-wind"/>
          <b>Frecuencia Respiratoria: {{ dataSignos.freqRespiratoria }} rpm</b>
        </h5>

        <h5 class="col-6 my-1"
        >  
          <i class="mr-1 fas fa-ring"/>
          <b>Peso: {{ dataSignos.peso }} KG </b>
        </h5>

        <h5 class="col-6 my-1"> 
          <i class="mr-1 fas fa-ruler"/> 
          <b>Talla:</b> {{ dataSignos.talla}} CM
        </h5>

        <h5 
          class="col-6 my-1"
          :class="dataSignos.imc > 25 ? 'signo-danger' : ''"> 
          <i class="mr-1 fas fa-calculator"/> 
          <b>IMC: {{ dataSignos.imc.toFixed(2)}} ({{ resultadoImc }}) </b>
        </h5>

        <h5 class="col-6 my-1">
          <i class="mr-1 fas fa-circle"></i> 
          <b>Perimetro Abdominal: </b> 
          {{ dataSignos.perimetroAbdominal === 0 ? "No disponible" : dataSignos.perimetroAbdominal}}
        </h5>

        <h5 class="col-6 my-1">  
          <i class="mr-1 fas fa-circle"/> 
          <b>Perimetro Cefalico:</b>
          {{ dataSignos.perimetroCefalico === 0 ? "No disponible" : dataSignos.perimetroCefalico }} 
        </h5>

      </b-row>
      
    </b-card>
  </b-modal>
</template>

<script>
import { BootstrapVue }               from 'bootstrap-vue';
import { signosVitalesService }       from '@/views/signosVitales/services';
import { calculateAgeWithDateString } from '../../shared/helpers';


export default {

  name: "SignoModalViewDetails",

  components: {
    ...BootstrapVue.components,
  },

  props: {
    tokenSignos: String,
  },

  data() {
    return {
      isVisible: false,

      temperaturaAlert : '',
      tensionAlert : '',
      freqRespiratoriaAlert : '',
      pulsoAlert : '',
      satOxigenoAlert : '',
      
      dataCita:null,
      dataSignos: null,
      dataPaciente: null,
    }
  },

  methods: {

    onHidden() {
      this.$emit('update:tokenSignos', null);
      this.isVisible = false;
    },

    alertaTension(){
      if(this.dataSignos.tensionArterialSistolica && this.dataSignos.tensionArterialDiastolica){
        const sistolica = this.dataSignos.tensionArterialSistolica
        const diastolica = this.dataSignos.tensionArterialDiastolica
      
        if(this.edadPaciente < 1){
          if(sistolica < 70 || sistolica > 100 || diastolica < 50 || diastolica > 70 ) {
            return 'signo-danger'
          }
        }

        if(this.edadPaciente >= 1 && this.edadPaciente <= 5){
          if(sistolica < 80 || sistolica > 110 || diastolica < 50 || diastolica > 80 ) {
            return 'signo-danger'
          }
        } 

        if(this.edadPaciente >= 6 && this.edadPaciente <= 12){
          if(sistolica < 90 || sistolica > 120 || diastolica < 60 || diastolica > 80 ) {
            return 'signo-danger'
          }
        }

        if(this.edadPaciente >= 13 && this.edadPaciente <= 18){
          if(sistolica < 110 || sistolica > 131 || diastolica < 64 || diastolica > 83 ) {
            return 'signo-danger'
          }
        }

        if(this.edadPaciente >= 18 && this.edadPaciente <= 64){
          if(sistolica < 90 || sistolica > 140 || diastolica < 60 || diastolica > 80 ) {
            return 'signo-danger'
          }
        }

        if(this.edadPaciente >= 65){
          if(sistolica < 90 || sistolica > 140 || diastolica < 60 || diastolica > 90 ) {
            return 'signo-danger'
          }
        }
      }
    },


    async loadData(){

      const responseSignos = await signosVitalesService.getByToken(this.tokenSignos);

      if(!responseSignos) return;

      this.dataCita     = responseSignos.cita;
      this.dataPaciente = responseSignos.cita.paciente.persona;
      this.edadPaciente = calculateAgeWithDateString(responseSignos.cita.paciente.persona.fechaNacimiento);
      this.dataSignos   = {
        ...responseSignos,
      }

      this.isVisible = true;

      const { temperatura, pulso, freqRespiratoria, satOxigeno } = responseSignos;

      this.tensionAlert    = this.alertaTension()

      if (this.edadPaciente < 1){
        if(temperatura < 36.5 || temperatura > 37.8) 
          this.temperaturaAlert = 'signo-danger';

        if(pulso < 100 || pulso > 160) 
          this.pulsoAlert = 'signo-danger';

        if(freqRespiratoria < 30 || freqRespiratoria > 60) 
          this.freqRespiratoriaAlert = 'signo-danger';

        if(satOxigeno < 95 ) 
          this.satOxigenoAlert = 'signo-danger';
      }


      if (this.edadPaciente >= 1 && this.edadPaciente <= 3){

        if(temperatura < 36.5 || temperatura > 37.8) 
          this.temperaturaAlert = 'signo-danger';

        if(pulso < 90 || pulso > 150) 
          this.pulsoAlert = 'signo-danger';

        if(freqRespiratoria < 24 || freqRespiratoria > 40) 
          this.freqRespiratoriaAlert = 'signo-danger';

        if(satOxigeno < 95 ) 
          this.satOxigenoAlert = 'signo-danger';
      }


      if (this.edadPaciente >= 4 && this.edadPaciente <= 5){

        if(temperatura < 36.5 || temperatura > 37.8) 
          this.temperaturaAlert = 'signo-danger';

        if(pulso < 80 || pulso > 140) 
          this.pulsoAlert = 'signo-danger';

        if(freqRespiratoria < 22 || freqRespiratoria > 34) 
          this.freqRespiratoriaAlert = 'signo-danger';
        
        if(satOxigeno < 95 )
          this.satOxigenoAlert = 'signo-danger';
      }


      if (this.edadPaciente >= 6 && this.edadPaciente <= 12){

        if(temperatura < 36.5 || temperatura > 37.8) 
          this.temperaturaAlert = 'signo-danger';

        if(pulso < 75 || pulso > 120) 
          this.pulsoAlert = 'signo-danger';

        if(freqRespiratoria < 18 || freqRespiratoria > 30) 
          this.freqRespiratoriaAlert = 'signo-danger';

        if(satOxigeno < 95 ) 
          this.satOxigenoAlert = 'signo-danger';
      }

      
      if (this.edadPaciente >= 13 && this.edadPaciente <= 18){

        if(temperatura < 36.1 || temperatura > 37.2) 
          this.temperaturaAlert = 'signo-danger';

        if(pulso < 60 || pulso > 100) 
          this.pulsoAlert = 'signo-danger';

        if(freqRespiratoria < 12 || freqRespiratoria > 20) 
          this.freqRespiratoriaAlert = 'signo-danger';

        if(satOxigeno < 95 ) 
          this.satOxigenoAlert = 'signo-danger';

      }


      if (this.edadPaciente > 18){
        if(temperatura < 36.1 || temperatura > 37.2) 
          this.temperaturaAlert = 'signo-danger';

        if(pulso < 60 || pulso > 100) 
          this.pulsoAlert = 'signo-danger';

        if(freqRespiratoria < 12 || freqRespiratoria > 20) 
          this.freqRespiratoriaAlert = 'signo-danger';

        if(satOxigeno < 95 ) 
          this.satOxigenoAlert = 'signo-danger';
      }
    }
  },


  watch: {
    tokenSignos: {
      deep: true,
      handler(newValue) {
        if(!newValue) return;
        this.loadData();
      }
    },
  
  },

  computed: {

    resultadoImc() {
     
      if (this.dataSignos.imc.toFixed(2) < 18.5 )
        return "Bajo peso";

      if (this.dataSignos.imc.toFixed(2) > 18.5 && this.dataSignos.imc.toFixed(2) < 24.9)
        return "Peso normal";

      if (this.dataSignos.imc.toFixed(2) > 25 && this.dataSignos.imc.toFixed(2) < 29.9 )
        return "Sobrepeso";

      if (this.dataSignos.imc.toFixed(2) > 30)
        return "Obesidad";
      
      return "";
    }
  }


}
</script>

<style >
.signo-danger > i, .signo-danger > b {
  border-radius: 6px; 
  color: red;
}

</style>